export const ZDASH_URL = process.env.VUE_APP_ZDASH_URL;
export const STRIPE_API_KEY = process.env.VUE_APP_STRIPE_API_KEY;
export const DASHBOARD_URL = process.env.VUE_APP_DASHBOARD_URL;

export const ERROR_MESSAGE = {
  unknown:
    "Unknown error has occurred, try again and contact us success@zyrl.us if there's still an error.",
};
